import { CSSTransition } from 'react-transition-group';
import { Box } from 'v1/ui';

const scoreTransTime = 600;
const scoreDelayTime = 400;

export function ScoreAppearTransition({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        '.score-appear.appear-active': {
          opacity: 0,
        },
        '.score-appear.appear-done': {
          opacity: 1,
          transition: `all ${scoreTransTime}ms ease-in-out`,
          transitionDelay: `${scoreDelayTime}ms`,
        },
      }}
    >
      <CSSTransition
        appear={true}
        in={true}
        className="score-appear"
        timeout={0}
      >
        {children}
      </CSSTransition>
    </Box>
  );
}

export function GroupAppearTransition({
  children,
  index,
}: {
  children: React.ReactNode;
  index: number;
}) {
  return (
    <Box
      sx={{
        '.group-appear.appear-active': {
          opacity: 0,
          transform: 'translateY(-100px)',
        },
        '.group-appear.appear-done': {
          opacity: 1,
          transform: 'translateY(0)',
          transition: `all 500ms ease-in-out`,
          transitionDelay: `${getTransitionDelay(index)}ms`,
        },
      }}
    >
      <CSSTransition
        appear={true}
        in={true}
        className="group-appear"
        timeout={0}
      >
        {children}
      </CSSTransition>
    </Box>
  );
}

function getTransitionDelay(index: number) {
  return scoreDelayTime + scoreTransTime / 1.75 + ((index * index) / 6) * 75;
}
